import { render, staticRenderFns } from "./tableRow.vue?vue&type=template&id=010fa611&scoped=true&"
import script from "./tableRow.vue?vue&type=script&lang=ts&"
export * from "./tableRow.vue?vue&type=script&lang=ts&"
import style0 from "./tableRow.vue?vue&type=style&index=0&id=010fa611&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010fa611",
  null
  
)

component.options.__file = "tableRow.vue"
export default component.exports